export const baseStyle = {
  button: { color: 'white', borderRadius: 20, paddingInline: 45 },
  row: { marginTop: 30 }
};
export const colors = {
  anytimeBlue: '#175FFF',
  anytimeViolet: '#A14EFF',
  anytimeGreen: '#84F22E',
  disabledGrey: '#E0E0E0',
  bgGrey: '#f5f5f5'
};
export const row = { marginTop: 30 };
